import React, { useState } from "react";
import { Box, Typography, Tab } from "@mui/material/";
import { TabContext, TabList, TabPanel } from "@mui/lab/";
import Assets from "./Assets";
import DataCheck from "./DataCheck";
import { strings } from "../common/i18n";
import styles from "./styles";
import { useLocation } from "react-router-dom";

export default () => {
    const loaction = useLocation();
    /** Condition for the user who access direct path to datacheck */
    const isDataCheck = location.search.split("=").pop();
    const [value, setValue] = useState(isDataCheck ? isDataCheck : "assets");
    const handleChange = (event, newValue) => setValue(newValue);

    return (
        <Box>
            <Box sx={styles.mainHeaderContainer}>
                <Typography variant="h6" sx={styles.tabHeader}>
                    {strings("assets")}
                </Typography>
            </Box>
            <TabContext value={value} sx={styles.tabContext}>
                <Box sx={styles.tabListContainer}>
                    <TabList onChange={handleChange}>
                        <Tab label={strings("allAssets")} value="assets" />
                        {/* <Tab label={strings("dataCheck")} value="dataCheck" /> */}
                    </TabList>
                </Box>
                <TabPanel value="assets" sx={styles.tabPanelList}>
                    <Assets />
                </TabPanel>
                <TabPanel value="dataCheck" sx={styles.tabPanelList}>
                    <DataCheck />
                </TabPanel>
            </TabContext>
        </Box>
    );
};
